import React from 'react';
import ResponsiveContainer from 'recharts/lib/component/ResponsiveContainer';
import LChart from 'recharts/lib/chart/LineChart';
import Line from 'recharts/lib/cartesian/Line';
import XAxis from 'recharts/lib/cartesian/XAxis';
import YAxis from 'recharts/lib/cartesian/YAxis';
import CartesianGrid from 'recharts/lib/cartesian/CartesianGrid';
import Tooltip from 'recharts/lib/component/Tooltip';
import Legend from 'recharts/lib/component/Legend';

class LineChart extends React.Component {
  render() {
    return (
      // 99% per https://github.com/recharts/recharts/issues/172
      <ResponsiveContainer width="99%" height={420}>
        <LChart data={this.props.data}>
          <XAxis dataKey="name" />
          <YAxis />
          <CartesianGrid vertical={false} strokeDasharray="3 3" />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="ajouté" stroke="#82ca9d" />
          <Line type="monotone" dataKey="modifié" stroke="#8884d8" activeDot={{ r: 8 }} />
        </LChart>
      </ResponsiveContainer>
    );
  }
}

export default LineChart;



// WEBPACK FOOTER //
// ./src/component/charts/LineChart.js